import { render, staticRenderFns } from "./FormLicenseUpload.vue?vue&type=template&id=9cd1c016&"
import script from "./FormLicenseUpload.vue?vue&type=script&lang=js&"
export * from "./FormLicenseUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports